
       <kendo-grid-columnmenu-item
            [text]="text"
            [icon]="icon"
            (itemClick)="toggleColumn()"
            [disabled]="disabled">
       </kendo-grid-columnmenu-item>
    